import { useQuery } from "react-query";
import http from "infra/http";
import { EspeciesDocResponse } from "../typings";

function useGetEspeciesDoc(bancoId: string) {
  return useQuery(
    `/v1/bancos/${bancoId}/especies-doc`,
    async () => {
      const { data } = await http.get<EspeciesDocResponse[]>(
        `/v1/bancos/${bancoId}/especies-doc`
      );

      return data;
    },
    {
      enabled: !!bancoId,
    }
  );
}

export default useGetEspeciesDoc;
